import {
  Box,
  Divider,
  IconButton,
  Modal,
  Radio,
  SelectChangeEvent,
  Stack,
  Typography,
} from "@mui/material";
import LoadingButton from "src/components/Buttons/LoadingButton";
import { useTranslation } from "react-i18next";
import { ShippingAddress } from "src/api/types";

interface AddressVerificationModalProps {
  showSuggestedAddress: boolean;
  setShowSuggestedAddress: (value: boolean) => void;
  suggestedAddress: ShippingAddress;
  loading: boolean;
  setSelectedOption: (value: string) => void;
  handleSelect: (e: SelectChangeEvent) => void;
  formData: ShippingAddress;
  selectedOption: string;
  handleAddShippingAddress: () => void;
}
const AddressVerificationModal = ({
  showSuggestedAddress,
  setShowSuggestedAddress,
  suggestedAddress,
  setSelectedOption,
  handleSelect,
  formData,
  selectedOption,
  loading,
  handleAddShippingAddress,
}: AddressVerificationModalProps) => {
  const page = "shipping-information";
  const { t } = useTranslation();

  return (
    <Modal
      open={showSuggestedAddress}
      onClose={() => setShowSuggestedAddress(false)}
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          bgcolor: "background.default",
          minWidth: 350,
          maxWidth: 450,
          maxHeight: "100%",
          overflow: "auto",
          p: 4,
          outline: "none",
          borderRadius: "16px",
        }}
      >
        <Stack
          direction="row"
          gap={2}
          alignItems="center"
          justifyContent="space-between"
        >
          <Typography variant="h5" sx={{ color: "#000000" }}>
            {t(`${page}.popup.title`)}
          </Typography>
          <IconButton onClick={() => setShowSuggestedAddress(false)}>
            X
          </IconButton>
        </Stack>
        <Divider />
        <Typography margin="1rem 0" sx={{ color: "#000000" }}>
          {t(`${page}.popup.subtitle`)}
        </Typography>
        <Typography sx={{ color: "#000000" }}>
          {t(`${page}.popup.entered`)}:
        </Typography>

        <Box
          display="grid"
          gridTemplateColumns="25px 1fr"
          gap="15px"
          margin="1rem 0"
          onClick={() => setSelectedOption("entered")}
          style={{ cursor: "pointer" }}
        >
          <Radio
            checked={selectedOption === "entered"}
            onChange={handleSelect}
            value="entered"
            name="radio-buttons"
            disableRipple={true}
          />
          <Stack gap={1}>
            <Typography style={{ fontSize: "15px" }} sx={{ color: "#000000" }}>
              {formData.address_line1}
            </Typography>
            {formData?.address_line2 && (
              <Typography
                style={{ fontSize: "15px" }}
                sx={{ color: "#000000" }}
              >
                {formData.address_line2}
              </Typography>
            )}
            <Typography style={{ fontSize: "15px" }} sx={{ color: "#000000" }}>
              {formData.city}
              {", "}
              {formData.state} {formData.zip_code}
            </Typography>
          </Stack>
        </Box>
        <Divider />

        <Typography margin="1rem 0" sx={{ color: "#000000" }}>
          {t(`${page}.popup.suggested`)}:
        </Typography>
        <Box
          display="grid"
          gridTemplateColumns="25px 1fr"
          gap="15px"
          onClick={() => setSelectedOption("suggested")}
          style={{ cursor: "pointer" }}
        >
          <Radio
            checked={selectedOption === "suggested"}
            onChange={handleSelect}
            value="suggested"
            name="radio-buttons"
            disableRipple={true}
          />
          <Stack gap={1}>
            <Typography style={{ fontSize: "15px" }} sx={{ color: "#000000" }}>
              {suggestedAddress.address_line1}
            </Typography>
            {suggestedAddress?.address_line2 && (
              <Typography
                style={{ fontSize: "15px" }}
                sx={{ color: "#000000" }}
              >
                {suggestedAddress.address_line2}
              </Typography>
            )}
            <Typography style={{ fontSize: "15px" }} sx={{ color: "#000000" }}>
              {suggestedAddress.city}
              {", "}
              {suggestedAddress.state} {suggestedAddress.zip_code}
            </Typography>
          </Stack>
        </Box>

        <LoadingButton
          loading={loading}
          size="small"
          style={{ marginTop: "2rem" }}
          fullWidth
          onClick={handleAddShippingAddress}
        >
          {t(`${page}.popup.submit`)}
        </LoadingButton>
      </Box>
    </Modal>
  );
};

export default AddressVerificationModal;
